import { FC } from 'react';

import { WarningIcon } from '../../../assets';
import { apiErrorMessage } from '../../../lib';
import { Button } from '../../button';
import { DialogClose } from '../../dialog';
import { ModalTemplate } from '../../templates';
import { IWrongModal, TWrongModalDescription } from './types';

const WrongModalDescription: FC<TWrongModalDescription> = ({
  error,
  description,
}) => {
  if (description && typeof description !== 'string') return description;
  return (
    <p className="mt-4 px-10 text-center text-base-300 typography-16r">
      {description ??
        apiErrorMessage(error, {
          defaultMessage:
            'Please check the accuracy of the information in the fields.',
        })}
    </p>
  );
};

export const WrongModal: FC<IWrongModal> = ({
  title = 'Something Went Wrong',
  description,
  buttonText = 'Try again',
  error,
  imgSrc = WarningIcon,
  onRetry,
}) => {
  return (
    <ModalTemplate
      id="Wrong modal"
      classNames={{ wrapper: 'md:max-w-[342px]' }}
      className="px-5 py-10"
    >
      <img
        src={imgSrc}
        alt="wrong icon image"
        className="mx-auto h-[164px] w-[164px]"
      />

      {typeof title === 'string' ? (
        <h1 className="mt-8 px-10 text-center heading-m">{title}</h1>
      ) : (
        title
      )}
      <WrongModalDescription error={error} description={description} />

      <DialogClose asChild>
        <Button
          size="md"
          onClick={onRetry}
          variant="modal-action"
          className="mx-auto mt-6 w-max"
        >
          {buttonText}
        </Button>
      </DialogClose>
    </ModalTemplate>
  );
};
